@if (isPlanningBasedOnPbp) {
  <div>
    <div class="validatable">
      <app-form-group>
        <label for="earliest-etaPBP">Earliest time of port entry</label>
        <app-date-field [(ngModel)]="context.visit.visitDeclaration.portVisit.portEntry.earliestTimeOfPortEntry"
                        [calendarStartDate]="context.visit.visitDeclaration.portVisit.portEntry.etaPilotBoardingPlace"
                        [disabled]="context.visitIsDeparted()" id="earliest-etaPBP"></app-date-field>
      </app-form-group>
    </div>
    @if (etaEarliestPBPIsAfterPBP()) {
      <span class="ng-invalid invalid-feedback mb-2">Earliest time of port entry should be before
      ETA pilot boarding place</span>
    }
  </div>
}
